import React from 'react';
import VolunteerNav from '../components/VolunteerNav';
import NotificationsList from '../components/NotificationsList';

const Notifications = () => {
  return (
    <div className="h-screen bg-gray-50 flex overflow-hidden">
      <VolunteerNav currentPage="Notifications" />

      <main className="flex-1 overflow-y-auto pt-16 lg:pt-0 h-screen">
        <div className="p-4 sm:p-6 lg:p-8">
          <NotificationsList isAdmin={false} />
        </div>
      </main>
    </div>
  );
};

export default Notifications;
